export default "__VITE_ASSET__BAqdQ4sg__"